<app-page-title title="Criança"></app-page-title>
<div class="member">
  <div class="card">
    <div class="photo">
      <img [src]="'../../../assets/images/child-' + child?.gender + '.png'" width="100" />
    </div>
    <div class="name">
      <p>{{ child?.name }}</p>
    </div>
    <div class="birth_date">
      <p>nascido em {{ child?.birth_date | date: 'dd/MM/yyyy' }}</p>
    </div>

    <div class="parents">
      <p *ngIf="!child?.father_id"><b>Pai </b> {{ child?.father_name }}</p>
      <div *ngIf="child?.father_id">
        <b>Pai </b><a [href]="'/membro/vizualizar/' + child?.father_id">{{ child?.father_name }}</a>
      </div>
    </div>
    <div class="parents">
      <p *ngIf="!child?.mother_id"><b>Mãe </b> {{ child?.mother_name }}</p>
      <div *ngIf="child?.mother_id">
        <b>Mãe </b><a [href]="'/membro/vizualizar/' + child?.mother_id">{{ child?.mother_name }}</a>
      </div>
    </div>
  </div>
</div>
